export default class ShowErrors {
  // taken from here: http://blog.yodersolutions.com/bootstrap-form-validation-done-right-in-angularjs/
  constructor() {
    this.restrict = "A";
    this.require = "^form";
  }

  link(scope, el, _, formCtrl) {

    var inputElement = el[0].querySelector("[name]");
    var inputNgElement = angular.element(inputElement);

    // get the name on the text box so we know the property to check
    // on the form controller
    var inputName = inputNgElement.attr('name');

    // only apply the has-error class after the user leaves the text box
    inputNgElement.bind('blur', function () {
      el.toggleClass('has-error', formCtrl[inputName].$invalid);
    });

    scope.$on('show-errors-check-validity', function () {
      el.toggleClass('has-error', formCtrl[inputName].$invalid);
    });
  }
}



// WEBPACK FOOTER //
// ./app/components/showErrors.js